import { render, staticRenderFns } from "./MonthlyPoints.vue?vue&type=template&id=70096686"
import script from "./MonthlyPoints.vue?vue&type=script&lang=js"
export * from "./MonthlyPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports